/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { LpTradeDto } from '../model/lpTradeDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface LpTradesReport1RequestParams {
  /** Included Client account ID for filtering. Can be filled if \&#39;excludeAccountIds\&#39; is empty. */
  accountId?: Array<number>;
  /** Excluded Client account IDs for filtering. Can be filled if \&#39;accountId\&#39; is empty. */
  excludeAccountIds?: Array<number>;
  /** Included Liquidity provider ID for filtering. Can be filled if \&#39;excludedLpIds\&#39; is empty. */
  lpId?: Array<number>;
  /** Excluded Liquidity provider ID for filtering. Can be filled if \&#39;lpId\&#39; is empty. */
  excludedLpIds?: Array<number>;
  /** If true - Show all order. Corrected orders as well. */
  canceled?: boolean;
  /** If true - Show orders with zero executed qty. */
  zeroExecutedQty?: boolean;
  /** Sort direction by time. ASC or DESC(default). */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0. */
  skipCount?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LPTradesControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets LP trades(up to 100)
   * @endpoint get /v1/lp-trades/lp-trades
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public lpTradesReport1(
    requestParameters?: LpTradesReport1RequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<LpTradeDto>>;
  public lpTradesReport1(
    requestParameters?: LpTradesReport1RequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<LpTradeDto>>>;
  public lpTradesReport1(
    requestParameters?: LpTradesReport1RequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<LpTradeDto>>>;
  public lpTradesReport1(
    requestParameters?: LpTradesReport1RequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const accountId = requestParameters?.accountId;
    const excludeAccountIds = requestParameters?.excludeAccountIds;
    const lpId = requestParameters?.lpId;
    const excludedLpIds = requestParameters?.excludedLpIds;
    const canceled = requestParameters?.canceled;
    const zeroExecutedQty = requestParameters?.zeroExecutedQty;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'accountId',
      <any>accountId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludeAccountIds',
      <any>excludeAccountIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'lpId',
      <any>lpId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'excludedLpIds',
      <any>excludedLpIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'canceled',
      <any>canceled,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'zeroExecutedQty',
      <any>zeroExecutedQty,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/lp-trades/lp-trades`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<LpTradeDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
